import Modal from 'react-overlays/Modal'
import Dropdown from 'react-dropdown'
export default function DeletePopupModal({
  setDeletePopupModal,
  deletePopupModal,
  onDelete,
  type,
}) {
  const handleClose = () => {
    setDeletePopupModal(false)
  }
  var handleSuccess = () => {}
  const renderBackdrop = (props) => <div className="backdrop" {...props} />
  return (
    <>
      <div
        className="bg-black bg-opacity-50 flex items-center justify-center fixed left-0 right-0 bottom-0 top-0 z-[200]"
        onClick={(e) => e.stopPropagation()}
      ></div>
      <div>
        <Modal
          className="modal"
          show={deletePopupModal}
          onHide={handleClose}
          renderBackdrop={renderBackdrop}
          style={{
            // display: 'flex',
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: type === 'Parcel' ? '-100px' : '-130px',
            marginLeft: '-200px',
            width: '400px',
            height: type === 'Parcel' ? '200px' : '260px',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1500,
          }}
        >
          <div>
            <div className="modal-header">
              <div className="modal-title">Delete {type}</div>
              <div>
                <span className="close-button" onClick={handleClose}>
                  x
                </span>
              </div>
            </div>
            <div className="modal-desc">
              <div>
                {type === 'Parcel' ? (
                  <strong>
                    You are about to delete your parcel from the ranch. Are you
                    sure you want to proceed?
                  </strong>
                ) : (
                  <strong>
                    You are about to delete your ranch. This action will
                    permanently remove all existing data associated with this
                    ranch, including parcels, ranch reports, and any other
                    related information. Are you sure you want to proceed?
                  </strong>
                )}
                <button
                  onClick={async () => {
                    onDelete()
                    handleClose()
                  }}
                  className="mt-3 px-7 py-3 bg-gray-600 text-white font-medium text-sm uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg w-full text-center transition duration-150 ease-in-out btn btn-custom delete-parcel"
                >
                  delete
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  )
}
